

































import {Component, Vue, Prop, Watch, Emit} from 'vue-property-decorator';
import {バラ単位区分型, 棚卸入力バリデータ一覧, 棚卸明細型} from '@/type/stocktaking/types';
import moment from 'moment';
import {loginModule} from '@/store/authentication/login';
import {ValidationResult} from '@/type/validation/result';

@Component({
  components: {
  },
})

export default class RegisterStocktakingDataRow extends Vue {
  // props
  @Prop()
  value!: 棚卸明細型;
  @Prop()
  rowIndex!: number;
  @Prop()
  unfixed!: boolean;

  // events
  @Emit()
  changeDerived(行番号: number, 実在庫換算数: number, 実在庫金額: number, 差数: number): object {
    return {行番号, 実在庫換算数, 実在庫金額, 差数};
  }

  @Watch('value.棚卸在庫.実在庫.箱数')
  private 箱数が変更された(): void {
    this.changeDerived(this.rowIndex, this.実在庫換算数, this.実在庫金額, this.差数);
  }

  @Watch('value.棚卸在庫.実在庫.バラ数')
  private バラ数が変更された(): void {
    this.changeDerived(this.rowIndex, this.実在庫換算数, this.実在庫金額, this.差数);
  }

  // computed
  get 箱管理である(): boolean {
    return loginModule.箱管理である;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 棚卸有効期限を表示する(): boolean {
    return loginModule.棚卸有効期限を表示する;
  }

  get 棚卸有効期限を表示しない(): boolean {
    return loginModule.棚卸有効期限を表示しない;
  }

  get 譲受カラムを表示する(): boolean {
    return loginModule.譲渡譲受を利用する;
  }

  get 未確定である(): boolean {
    return this.unfixed;
  }

  get 実在庫箱数(): number {
    const 実在庫箱数 = this.value.棚卸在庫.実在庫.箱数;
    if (!実在庫箱数) {
      return 0;
    }
    return 実在庫箱数;
  }

  get 実在庫バラ数(): number {
    const 実在庫バラ数 = this.value.棚卸在庫.実在庫.バラ数;
    if (!実在庫バラ数) {
      return 0;
    }
    return 実在庫バラ数;
  }

  get 実在庫換算数of箱(): number {
    if (this.箱管理である) {
      return this.実在庫箱数;
    } else {
      return this.実在庫箱数 * this.value.棚卸商品.入数;
    }
  }

  get 実在庫換算数ofバラ(): number {
    if (this.value.棚卸商品.バラ単位区分 === バラ単位区分型.包装単位) {
      return this.実在庫バラ数;
    } else {
      return this.実在庫バラ数 * this.value.棚卸商品.包装単位数;
    }
  }

  get 実在庫換算数(): number {
    if (this.箱管理である) {
      return this.実在庫換算数of箱;
    } else {
      return this.実在庫換算数of箱 + this.実在庫換算数ofバラ;
    }
  }

  get 納入単価(): number {
    const 納入単価 = this.value.在庫金額.納入単価;
    if (!納入単価) {
      return 0;
    }
    return 納入単価;
  }

  get 実在庫金額of箱(): number {
    return this.実在庫箱数 * this.納入単価;
  }

  get 実在庫金額ofバラ(): number {
    // 整数に切り捨て
    return Math.floor(this.実在庫換算数ofバラ * this.納入単価 / this.value.棚卸商品.入数);
  }

  get 実在庫金額(): number {
    return this.実在庫金額of箱 + this.実在庫金額ofバラ;
  }

  get 差数(): number {
    if (this.箱管理である) {
      return this.差数of箱管理;
    } else {
      return this.差数ofバラ管理;
    }
  }

  get 差数of箱管理(): number {
    return this.実在庫箱数 - this.value.棚卸在庫.理論在庫.箱数;
  }

  get 実在庫数バラ総数(): number {
    if (this.value.棚卸商品.バラ単位区分 === バラ単位区分型.包装単位) {
      return this.実在庫箱数 * this.value.棚卸商品.入数 + this.実在庫バラ数;
    } else {
      return this.実在庫箱数 * this.value.棚卸商品.包装数量数 + this.実在庫バラ数;
    }
  }

  get 差数ofバラ管理(): number {
    // 小数点第四位で四捨五入
    return Math.round((this.実在庫数バラ総数 - this.value.棚卸在庫.理論在庫.バラ数) * 1000) / 1000;
  }

  get 実在庫箱数Style(): object {
    return {'input-error': this.入力エラーが存在する('棚卸在庫.実在庫.箱数')};
  }

  get 実在庫バラ数Style(): object {
    return {'input-error': this.入力エラーが存在する('棚卸在庫.実在庫.バラ数')};
  }

  // methods
  private 入力エラーが存在する(項目名: string): boolean {
    const checker = new ValidationResult(棚卸入力バリデータ一覧);
    checker.validate(this.value);
    return checker.hasError(項目名);
  }
}
